import { useEffect, useState } from "react";

const MINUTE_MS = 60_000;

/**
 * The time now, kept current for a line that says «Abierto ahora»: every
 * minute, and at once when the page comes back -- the tab shown again, or
 * «atrás» restoring it from the back-forward cache hours later.
 */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const tick = (): void => setNow(new Date());
    const onVisible = (): void => {
      if (document.visibilityState === "visible") tick();
    };
    const timer = window.setInterval(tick, MINUTE_MS);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("pageshow", tick);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("pageshow", tick);
    };
  }, []);
  return now;
}
